import { render, staticRenderFns } from "./DistributorListTable.vue?vue&type=template&id=6d1aeb18&scoped=true"
import script from "./DistributorListTable.vue?vue&type=script&lang=js"
export * from "./DistributorListTable.vue?vue&type=script&lang=js"
import style0 from "./DistributorListTable.vue?vue&type=style&index=0&id=6d1aeb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1aeb18",
  null
  
)

export default component.exports